import { createFileRoute } from "@tanstack/react-router";
import { ProtectedPage } from "../app/route-boundaries";
import { AdminSupportPage } from "../pages/AdminSupportPage";
export const Route=createFileRoute("/app/support/products")({component:()=> <ProtectedPage><AdminSupportPage section="products" /></ProtectedPage>});
